import { Box, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { theme } from "theme/theme";
import { formatDate, formatTimestampToDate } from "utils/formats";

interface DropdownItemProps {
  title: string;
  text: string;
  notificationCount: number;
  date: string;
  onClick?: () => void;
}

export const DropdownItem = ({ title, text, notificationCount, date, onClick }: DropdownItemProps) => {
  const { t } = useTranslation();
  const today = new Date();
  const notificationDate = formatTimestampToDate(date);
  const isToday = notificationDate.toDateString() === today.toDateString();

  return (
    <MenuItem onClick={onClick}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Box>
          <Typography variant="subtitle1" color="white">
            {t(`account.notifications.headlines.${title}`)}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="caption" color="white" fontFamily={theme.typography.fontFamily}>
              {text}
            </Typography>

            <Typography variant="caption" color="white" fontFamily={theme.typography.fontFamily}>
              {isToday ? t("common.time.today") : formatDate(notificationDate)}
            </Typography>
          </Box>
        </Box>
        <Box marginX={3} />
        <Box>
          <Typography
            variant="body2"
            fontFamily={theme.typography.fontFamily}
            sx={{
              position: "absolute",
              right: "1em",
              top: "20%",
              backgroundColor: notificationCount === 0 ? "grey.500" : "secondary.main",
              color: "white",
              borderRadius: "50%",
              width: { xs: "24px", sm: "28px", md: "32px" },
              height: { xs: "24px", sm: "28px", md: "32px" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
            }}
          >
            {notificationCount}
          </Typography>
        </Box>
      </Box>
    </MenuItem>
  );
};
